// extracted by mini-css-extract-plugin
module.exports = {"corrent":"why-module--corrent--2h8uw","whycontainer":"why-module--whycontainer--2i5Dk","rowpadding":"why-module--rowpadding--Nkx0I","li":"why-module--li--1_j_k"};